@let reviewForm = formService.form;
@let shouldShowError = reviewForm.errors?.instancePhotoRequired;

<div [formGroup]="reviewForm">
  <app-pan-form-control>
    <app-pan-floating-label [required]="true">Incident Photos</app-pan-floating-label>

    <app-pan-filepicker
      #uploadField
      [previewUrls]="imageUrls()"
      [invalid]="!!shouldShowError"
      (selected)="upload.emit($event)"
      (remove)="removeImageUrl($event)"
      data-testid="instancePhotoDropzone"
    >
      <ng-template let-url let-remove="remove">
        <app-pan-image-preview-button [src]="url" [alt]="''" [modalTitle]="'Incident Photo'" [modalTopLevel]="false">
          <ng-container footerActions>
            <swal
              #removeSwal
              title="Remove file?"
              text="Are you sure you want to remove this file?"
              icon="warning"
              confirmButtonText="Yes, Remove"
              [showCancelButton]="true"
              [focusCancel]="true"
              (confirm)="remove()"
            >
            </swal>

            <app-pan-button color="danger" [swal]="removeSwal">Remove</app-pan-button>
          </ng-container>
        </app-pan-image-preview-button>
      </ng-template>
    </app-pan-filepicker>

    @if (hasKioskPhoto()) {
      <span>Or</span>
      <div class="relative">
        <label class="w-1/3">
          <input type="checkbox" panCheckbox [formControl]="reviewForm.controls.useKioskPhoto" />
          Use Kiosk Photo
        </label>
      </div>
    }

    @if (shouldShowError) {
      <div class="text-danger mt-1" role="alert" data-testid="instancePhotoError">At least one incident photo is required.</div>
    }

    <div class="gap-2 flex flex-row flex-wrap mt-3">
      @for (file of reviewForm.controls.existingUniqueInstancePhoto.value; track $index) {
        <app-pan-image-preview-button [src]="file" [alt]="''" [modalTitle]="'Incident Photo'" [modalTopLevel]="false">
          <ng-container footerActions>
            <swal
              #removeExistingImageSwal
              title="Remove Incident Photo?"
              text="Are you sure you want to remove this incident photo?"
              icon="warning"
              confirmButtonText="Yes, Remove"
              [showCancelButton]="true"
              [focusCancel]="true"
              (confirm)="removeLink(file)"
            >
            </swal>

            <app-pan-button color="danger" [swal]="removeExistingImageSwal">Remove</app-pan-button>
          </ng-container>
        </app-pan-image-preview-button>
      }
    </div>
  </app-pan-form-control>
</div>
